import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import TopCarousel from "./Home/TopCarousel";
import Reviews from "./Reviews";
import Tours from "./Tours";
import Banner from "./Banner";
import ScrollReveal from "./ScrollReveal";
import PageSEO from "./PageSEO";
import TrustBadge from "./TrustBadge";
import { PAGES, pageMeta } from "../seo/pages";
import { NAP, REVIEW_STATS, SOCIAL } from "../seo/site";
import { cld } from "../seo/tourSeo";

const woodgrain = {
  backgroundImage: `url('${cld("f_auto,q_auto", "img/wooden-texture2.webp")}')`,
  backgroundRepeat: "repeat",
};

const TRIPADVISOR_LOGO = cld("c_fit,w_640,h_96/f_auto,q_auto", "img/home/tripadvisor-logo");
const TRIPADVISOR_AWARD = cld("c_fit,w_238,h_40/f_auto,q_auto", "img/home/tripadvisor1");
const PRIVATE_TOUR_IMG = cld("c_fill,w_540,h_360/f_auto,q_auto", "img/home/private_tour");

const Body = () => (
  <div style={woodgrain}>
    <PageSEO {...pageMeta("home")} />

    <TopCarousel />

    {/* ── Intro ── */}
    <section style={woodgrain}>
      <Container className="home-intro">
        <ScrollReveal>
          <div className="glass-card" style={{ marginBottom: 0 }}>
            <h1 className="home-intro__title">{PAGES.home.h1}</h1>
            <p style={{ marginBottom: 0 }}>
              When you're looking for things to do in Cincinnati, American Legacy Tours has you
              covered with the best walking &amp; bus tours in Cincinnati, Newport, and Covington.
              Our walking tours range from Food and Drink Tours and Underground Tours to Historic
              Tours and Haunted Tours. Explore the city and experience Cincinnati like never before
              with historically entertaining tours from American Legacy Tours.
            </p>
          </div>
        </ScrollReveal>
      </Container>
    </section>

    {/* ── All Tours ── */}
    <div id="tours" style={{ ...woodgrain, textAlign: "center" }}>
      <ScrollReveal>
        <h2 className="section-title">All Tours</h2>
      </ScrollReveal>
      <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Tours />
      </Container>
    </div>

    {/* ── TripAdvisor ── */}
    <section className="tripadvisor-section">
      <Container>
        <ScrollReveal direction="scale">
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <img src={TRIPADVISOR_LOGO} width="320" height="48" alt="TripAdvisor" loading="lazy" />
              <p className="tripadvisor-awards">
                {REVIEW_STATS.awardYears} Travelers&rsquo; Choice Award &amp; Certificate of Excellence
              </p>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, flexWrap: "wrap" }}>
                <img src={TRIPADVISOR_AWARD} width="119" height="20" alt="TripAdvisor Travelers' Choice" loading="lazy" />
                <TrustBadge variant="dark" link={false} />
                <a href={SOCIAL.tripadvisor} className="btn-brand" target="_blank" rel="noopener noreferrer">
                  View on TripAdvisor
                </a>
              </div>
            </Col>
          </Row>
        </ScrollReveal>
      </Container>
    </section>

    {/* ── Promo Banner ── */}
    <Banner />

    {/* ── Reviews ── */}
    <section className="reviews-section">
      <Container>
        <ScrollReveal>
          <Row style={{ marginLeft: 0, marginRight: 0 }}>
            <Reviews numToDisplay={4} />
          </Row>
        </ScrollReveal>
        <Row>
          <Col style={{ textAlign: "center", marginTop: 32 }}>
            <Link to="/reviews" className="btn-outline-light-custom">
              Read More Reviews
            </Link>
          </Col>
        </Row>
      </Container>
    </section>

    {/* ── Questions + Private Tours ── */}
    <section className="private-section">
      <Container>
        <Row className="align-items-center">
          <Col md={7} className="mb-4 mb-md-0">
            <ScrollReveal direction="left">
              <img
                className="w-100"
                src={PRIVATE_TOUR_IMG}
                width="540"
                height="360"
                style={{ borderRadius: 8, height: "auto" }}
                loading="lazy"
                alt="A private group enjoying an American Legacy Tours walking tour"
              />
            </ScrollReveal>
          </Col>
          <Col md={5}>
            <ScrollReveal direction="right" delay={100}>
              <h3>Questions?</h3>
              <p>
                If you have any other questions, we'd be happy to help. Check out our{" "}
                <Link to="/faq">Frequently Asked Questions</Link> or <Link to="/contact-us">contact us directly</Link>.
              </p>
              <a href={NAP.telephoneHref} className="btn-brand" style={{ marginBottom: 32, display: "inline-block" }}>
                {NAP.telephoneDisplay}
              </a>

              <h3 style={{ marginTop: 32 }}>Private Tours</h3>
              <p>
                American Legacy Tours are the perfect way for your company, family, and friends to
                spend time together. Each tour can be customized for your group, and we can handle
                transportation, meals, and lodging too.
              </p>
              <Link to="/private-tours" className="btn-brand">
                Inquire About Private Tours
              </Link>
            </ScrollReveal>
          </Col>
        </Row>
      </Container>
    </section>
  </div>
);

export default Body;
